import { GameSpineUtil } from "../../../../../utils/GameSpineUtil";
import { TitanTextResize } from "../../../../../utils/TitanTextResizer";
/**
 * A pair of label and value for a specific state of the PayTable
 */
export class PayTableCellStatePair {
    constructor(landscapeProperties, portraitProperties) {
        if (landscapeProperties.label) {
            this.label = TitanTextResize.createField(undefined, "label", landscapeProperties.label, portraitProperties?.label);
        }
        if (landscapeProperties.value) {
            this.value = TitanTextResize.createField(undefined, "value", landscapeProperties.value, landscapeProperties?.value);
        }
    }
    getValueElement() {
        return this.value;
    }
    getLabelElement() {
        return this.label;
    }
    setValue(value) {
        this.value?.setText(value, true);
    }
    setLabel(value) {
        this.label?.setText(value, true);
    }
    slotInSpine(spine, labelSlot, valueSlot) {
        if (this.label) {
            GameSpineUtil.getSlot(spine, labelSlot)?.addChild(this.label);
        }
        if (this.value) {
            GameSpineUtil.getSlot(spine, valueSlot)?.addChild(this.value);
        }
    }
    toggleVisible(visible, animate = false) {
        gsap.to([this.label, this.value].filter(Boolean), {
            alpha: visible ? 1 : 0,
            duration: animate ? 0.5 : 0
        });
    }
}
//# sourceMappingURL=PayTableCellStatePair.js.map